import { Button } from "antd";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { CustomIcon } from "datastake-daf/dist/components";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import ModalFilters from "../../../screens/Modules/pme/screens/dashboard/sections/progressive-modal-filters/filtersRow";

export const isNotEmpty = (myString) => /\S/.test(myString);

export default function TableFilters({
  setActiveFilters = () => { },
  t = (s) => s,
  search: tableSearch = '',
  setSearch: setTableSearch = () => { },
  filtersInit = [],
  injectCountry = true,
  activeFiltersInit = {},
  className,
}) {
  const [search, setSearch] = useState(tableSearch);
  const [filtersVisible, setFiltersVisible] = useState(Object.keys(activeFiltersInit).length ? true : false);
  const [clearFilters, setClearFilters] = useState(false);
  const { options } = useSelector((state) => state.project.data);
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    if (isNotEmpty(tableSearch)) {
      setIsTyping(true);
    } else if (isTyping) {
      setIsTyping(false);
    }
  }, [tableSearch]);

  const initialFilters = useMemo(() => !injectCountry ? filtersInit : [
    ...filtersInit,
    {
      items: (options?.countries || []),
      key: 'country',
      label: 'Country',
      optionsName: 'countries',
      placeholder: `${t('Select')} ${t('Country')}`,
      type: 'select',
    },
  ], [options, filtersInit, t]);

  return (
    <div className="mb-6">
      <div className="flex-row daf-search-filters">
        <div className="input-container">
          <div className={`input`}>
            <div className="flex-1">
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={t('Search')}
                onKeyUp={(e) => {
                  if (e.key === 'Enter') {
                    setTableSearch(search);
                    // setTypeIsOpen(false);
                  }
                }}
              />
            </div>
            <div className="search-icon">
              <SearchOutlined />
            </div>
            {((isTyping)) ? (
              <div className="mr" onClick={() => {
                setSearch('');
                setTableSearch('');
              }}>
                <CloseOutlined />
              </div>
            ) : null}
          </div>
        </div>
        <div className='flex flex-column'>
          <Button
            className="ml-3 flex-1"
            onClick={() => {
              setFiltersVisible((p) => !p);
            }}
          >
            <div className='flex flex-column justify-content-center'>
              <CustomIcon name='Filter' width={16} height={16} />
            </div>
          </Button>
        </div>
      </div>
      <div className="flex-r">
        <ModalFilters
          initialFilters={initialFilters}
          setFiltersVisible={setFiltersVisible}
          filtersVisible={filtersVisible}
          className={className}
          clearFilters={clearFilters}
          setClearFilters={setClearFilters}
          activeFiltersInit={activeFiltersInit}
          onSubmit={(v) => {
            setActiveFilters(v);
            setTableSearch(search);
          }}
          t={t}
        />
      </div>
    </div>
  )
}
